import { RequiredActionOutput } from '@coverright/data-access/types/enrollment';

export enum RequiredActionTypeOutput {
  ActionRequiredSetNoShow = 'ACTION_REQUIRED_SET_NO_SHOW',
  AppointmentReminderRequiredAgentConfirmation = 'APPOINTMENT_REMINDER__REQUIRED_AGENT_CONFIRMATION',
  AppointmentReminderAgentConfirmedButWillBeLateRequiredCsrAction = 'APPOINTMENT_REMINDER__AGENT_CONFIRMED_BUT_WILL_BE_LATE__REQUIRED_CSR_ACTION',
  AppointmentReminderSuggestedToRescheduleAppointmentByAgentRequiredAgentAction = 'APPOINTMENT_REMINDER__SUGGESTED_TO_RESCHEDULE_APPOINTMENT_BY_AGENT__REQUIRED_AGENT_ACTION',
  AppointmentReminderRequiredRescheduleOnAnotherTimeRequiredCsrAction = 'APPOINTMENT_REMINDER__REQUIRED_RESCHEDULE_ON_ANOTHER_TIME__REQUIRED_CSR_ACTION',
  AppointmentReminderRequiredRescheduleOnAnotherAgentRequiredCsrAction = 'APPOINTMENT_REMINDER__REQUIRED_RESCHEDULE_ON_ANOTHER_AGENT__REQUIRED_CSR_ACTION',
  AppointmentReminderCreatedNewAppointmentWithAnotherAgentRequiredAgentAction = 'APPOINTMENT_REMINDER__CREATED_NEW_APPOINTMENT_WITH_ANOTHER_AGENT__REQUIRED_AGENT_ACTION',
  AppointmentReminderAppointmentIsRescheduledOnAnotherTimeRequiredAgentAction = 'APPOINTMENT_REMINDER__APPOINTMENT_IS_RESCHEDULED_ON_ANOTHER_TIME__REQUIRED_AGENT_ACTION',
  AppointmentReminderCsrAcknowledgedAgentWillBeLateRequiredAgentAction = 'APPOINTMENT_REMINDER__CSR_ACKNOWLEDGED_AGENT_WILL_BE_LATE__REQUIRED_AGENT_ACTION',
  AppointmentReminderAgentHas5MinBeforeAppointmentRequiredCsrAction = 'APPOINTMENT_REMINDER__AGENT_HAS_5_MIN_BEFORE_APPOINTMENT__REQUIRED_CSR_ACTION',
}

export type RequiredActionProps = {
  item: RequiredActionOutput,
  onResolved: () => void,
  onHide?: () => void,
}
